.amount {
  font-weight: 500;
}

.comment {
  max-width: 80%;
}

.actionContainer {
  display: flex;
  flex-direction: column;
  text-align: right;
}
